import { Link, LinkProps, Stack } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props extends LinkProps {
  children: React.ReactNode;
  icon?: React.ReactNode;
  disabled?: boolean;
}

const PaiLinkAlt: React.FC<Props> = ({ children, disabled, ...props }) => {
  const { classes, cx } = useStyles();
  const { icon } = props;

  return (
    <Stack direction={'row'} alignItems={'center'} gap={1}>
      <Link className={cx(classes.paiLinkAlt, disabled && classes.disabled)} {...props}>
        {children}
      </Link>
      {icon && <span className={classes.icon}>{icon}</span>}
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  paiLinkAlt: {
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.primary.main,
    },
    textUnderlineOffset: '4px',
  },
  disabled: {
    cursor: 'not-allowed',
    color: theme.palette.action.disabled,
    pointerEvents: 'none',
  },
  icon: {
    '& .MuiSvgIcon-root': {
      fontSize: theme.typography.pxToRem(18),
      color: theme.palette.primary.main,
    },
  },
}));

export default PaiLinkAlt;
